<template>
  <YandexMapControl v-model="map">
    <div class="zoom-controls">
      <div class="zoom-button zoom-in" @click="changeZoom(1)">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 9H17M9 1L9 17"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="zoom-button zoom-out" @click="changeZoom(-1)">
        <svg
          width="18"
          height="2"
          viewBox="0 0 18 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1H17"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </YandexMapControl>
</template>

<script>
import { YandexMapControl } from "vue-yandex-maps";
import { shallowRef } from "vue";

export default {
  components: {
    YandexMapControl,
  },
  props: {},
  setup() {
    const map = shallowRef(null);

    const changeZoom = (val) => {
      map.value.root.update({
        location: {
          zoom: map.value.root.zoom + val,
          duration: 400,
          // easing: this._props.easing
        },
      });
    };

    return {
      map,
      changeZoom,
    };
  },
};
</script>

<style>
.zoom-controls {
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: hidden;
}

.zoom-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #d3d0ff, #ff0020, #fff);
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.zoom-button:hover {
  background: linear-gradient(135deg, #d3d0ff, #ff0020);
}

.zoom-button:active {
  background: linear-gradient(135deg, #d3d0ff, #ff0020);
}

.zoom-in {
  border-bottom: 1px solid #eee;
}

@media (max-width: 991px) {
  .zoom-controls {
    right: 24px;
    bottom: 40%;
  }
}

.ymaps3--control__background {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
